export default __webpack_public_path__ + "static/media/iphone-mockups.028932de.png";